export default __webpack_public_path__ + "static/media/clientTwelve.dce28532.png";